<template>
  <div class="orgdetails" v-if="org">
    <v-container class="pt-10">
      <div>
        <v-row class="px-3 pt-1 mb-6">
          <v-responsive class="overflow-visible">
            <h1 class="subheading grey--text">
              {{ org.name }}
            </h1>
          </v-responsive>
          <v-btn
            dark
            class="primary"
            @click.prevent="dialogAddUserToOrg = true"
          >
            Add User
          </v-btn>
        </v-row>

        <v-row class="px-3 pt-1 mb-6">
          <DataSummaryUsers
            :orgId="this.$route.params.id"
            userId=""
            :key="`${datesrange[0]}+${datesrange[1]}+'0'`"
          />
          <DataSummaryTranscripts
            :orgId="this.$route.params.id"
            userId=""
            :key="`${datesrange[0]}+${datesrange[1]}+'1'`"
          />
        </v-row>

        <UsageTimeChart
          :orgId="this.$route.params.id"
          userId=""
          :key="`${datesrange[0]}+${datesrange[1]}+'5'`"
        />

        <UsersTranscTable
          :orgId="this.$route.params.id"
          userId=""
          :key="`${datesrange[0]}+${datesrange[1]}+'3'`"
        />
        <TranscTable
          :orgId="this.$route.params.id"
          userId=""
          :key="`${datesrange[0]}+${datesrange[1]}+'2'`"
        />
        <UsersNotActivatedTable
          :orgId="this.$route.params.id"
          userId=""
          :key="`${datesrange[0]}+${datesrange[1]}+'4'`"
        />

        <v-row class="px-3 pt-1 mb-6">
          <v-col cols="12" sm="12" md="12">
            <v-card>
              <v-card-title>
                Special features
                <v-spacer></v-spacer>
              </v-card-title>
              <SpecialFeaturesCompany
                :featuresAlreadyEnabled="this.org.features"
                :orgId="this.org.id"
                :key="JSON.stringify(this.org)"
              />
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <!-- Dialog to add a user -->
    <v-dialog v-model="dialogAddUserToOrg" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Add New User to
            <span class="font-weight-medium">{{ org.name }}</span></span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Email*"
                  v-model="newUserEmail"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Full Name*"
                  v-model="newUserName"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-checkbox
                  v-model="checkboxIsOfOrg"
                  label="add user to this org"
                ></v-checkbox>
                <p v-if="!checkboxIsOfOrg" style="color: red">
                  User will be created without org, with a standard pricing
                </p>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          <p>
            This creates a user and automatically adds it to the
            {{ org.name }} organization.
          </p>
          <p>Pass: welcomelstn</p>
        </v-card-text>
        <v-card-actions>
          <p v-if="feedback" class="red--text pl-5">{{ feedback }}</p>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAddUserToOrg = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="addUserToOrg">Add User to Org</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar
      :text="snackbarText"
      :isopen="snackbarIsOpen"
      :color="snackbarColor"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fb, organizationsCollection } from "@/plugins/firebase.js";

export default {
  name: "OrganizationDetails",
  title: "OrgDetails",

  components: {
    Snackbar: () => import("@/components/Snackbar"),
    DataSummaryUsers: () => import("@/components/data/DataSummaryUsers"),
    DataSummaryTranscripts: () =>
      import("@/components/data/DataSummaryTranscripts"),
    TranscTable: () => import("@/components/data/TranscTable"),
    UsersTranscTable: () => import("@/components/data/UsersTranscTable"),
    UsersNotActivatedTable: () =>
      import("@/components/data/UsersNotActivatedTable"),
    UsageTimeChart: () =>
      import("@/components/charts/UsageTimeChart"),
    SpecialFeaturesCompany: () =>
      import("@/components/misc/SpecialFeaturesCompany"),
  },

  data() {
    return {
      org: null,

      dialogAddUserToOrg: false,
      newUserEmail: null,
      newUserName: null,
      checkboxIsOfOrg: true,
      feedback: null,

      snackbarIsOpen: false,
      snackbarColor: "success",
      snackbarText: "",
    };
  },
  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
    newuser() {
      let a = {
        email: "",
        displayName: "",
        selectedPlan: "",
        orgId: "",
        isEnterprise: false,
        checkboxIsOfOrg: true,
        country_code: "IT",
        preferredLanguage: "it",
      };
      a.email = this.newUserEmail;
      a.displayName = this.newUserName;
      if (this.checkboxIsOfOrg) {
        a.orgId = this.org.id;
        a.selectedPlan = this.org.id;
        a.isEnterprise = true;
      } else {
        a.selectedPlan = "lstn-advanced-monthly-eur";
      }
      return a;
    },
  },
  methods: {
    seeUser(value) {
      this.$router.push(`/users/${value.id}`);
    },
    async fetchOrganizationInfo(id) {
      let doc = await organizationsCollection.doc(id).get();
      let org = doc.data();
      org.id = doc.id;
      this.org = org;
    },
    async addUserToOrg() {
      const addandsubscribe = fb
        .app()
        .functions("europe-west1")
        .httpsCallable("adminCreateAddUserToOrg");
      try {
        this.dialogAddUserToOrg = false;
        await addandsubscribe(this.newuser);
        this.newUserEmail = null;
        this.newUserName = null;
        this.checkboxIsOfOrg = true;
        this.snackbarIsOpen = true;
        this.snackbarText = "user added";
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {},
  created() {
    this.fetchOrganizationInfo(this.$route.params.id);
  },
};
</script>

<style scoped>
.start-button {
  max-width: 20px;
}
</style>